const agreement = `<!DOCTYPE html>
<html lang="en-US">
	<head>
<meta name="viewport" content="width=device-width, initial-scale=1.0">
		<meta charset="utf-8" />
		<title>
		</title>
		<style>
			body { font-family:Calibri; font-size:12pt }
			p { margin:0pt }
			li { margin-top:0pt; margin-bottom:0pt }
			.BalloonText { font-family:SimSun; font-size:9pt }
			.CommentSubject { font-size:12pt; font-weight:bold }
			.CommentText { font-size:12pt }
			.Footer { font-size:9pt }
			.Header { text-align:center; border-bottom:0.75pt solid #000000; padding-bottom:1pt; font-size:9pt }
			.ListParagraph { margin-left:36pt; font-size:12pt }
			.NormalWeb { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }
			.Revision { font-size:12pt }
			span.BalloonTextChar { font-family:SimSun; font-size:9pt }
			span.CommentReference { font-size:10.5pt }
			span.CommentSubjectChar { font-size:12pt; font-weight:bold }
			span.CommentTextChar { font-size:12pt }
			span.FooterChar { font-size:9pt }
			span.HeaderChar { font-size:9pt }
			span.Strong { font-weight:bold }
		</style>
	</head>
	<body>
			<p style="text-align:center; font-size:14pt">
				<strong><span style="font-family:SimSun; ">《培声儿童早期语言家庭训练指导数字化系统》</span></strong>
			</p>
			<p style="text-align:center; font-size:14pt">
				<strong><span style="font-family:SimSun; ">说明及使用条款</span></strong>
			</p>
			<p>
				<strong>&#xa0;</strong>
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">关于培声儿童早期语言家庭训练指导数字化系统</span></u></strong>
			</p>
			<p>
				&#xa0;
			</p>
			<p class="NormalWeb">
				<span style="font-family:SimSun">“同看、同玩、同说”家长指导，即培声儿童早期语言家庭训练指导数字化系统（以下简称“本系统”），是一套帮助家长学习“同看、同玩、同说”早期语言家庭干预策略，以便在早期家庭干预中促进孩子语言能力发展的家庭指导循证数字化系统。由儿童语言发展专业机构——培声听力语言中心根据北美权威的儿童语言发展家长教育及家庭康复理念与实践设计而成。本系统包含</span><span class="Strong" style="font-family:SimSun; font-weight:normal">北美资深言语语言病理学家讲解与儿童真实互动的视频，将“同看、同玩、同说”高效互动策略化繁为简，手把手地教家长有趣高效地学习科学循证的语言家庭指导课程。</span>
			</p>
			<p>
				<span style="font-family:SimSun">&#xa0;</span>
			</p>
			<p>
				<span style="font-family:SimSun">使用本系统，家长可以：</span>
			</p>
			<p>
				<span style="font-family:SimSun">&#xa0;</span>
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:SimSun">学习科学循证的语言家庭课程并进行答题闯关</span>
				</li>
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:SimSun">观看北美资深言语语言病理学家拍摄的儿童互动视频</span>
				</li>
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:SimSun">为儿童制定家庭干预活动计划</span>
				</li>
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:SimSun">上传与孩子的互动阶段性视频并进行自我评价</span>
				</li>
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:SimSun">查看由言语语言治疗师撰写的“同看、同玩、同说”活动建议</span>
				</li>
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:SimSun">由儿科医生或言语语言治疗师对视频进行反馈</span>
				</li>
			</ul>
			<p>
				<span style="font-family:SimSun">&#xa0;</span>
			</p>
			<p>
				<span style="font-family:SimSun">为了帮助家长抓住儿童干预和成长的关键时期，本系统使用期限设定为4个月，建议家长于3个月内完成所有学习及练习。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">自备设备</span></u></strong>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">使用本课程系统时，您需自行准备与相关服务有关的终端设备（如电脑、移动终端和必要的网络接入设备等装置），并承担所需的费用（如电话费、上网费等费用）。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">您理解并同意，您使用本课程系统时会耗用您的终端设备和和移动网络等资源。</span>
			</p>
			<p>
				<strong>&#xa0;</strong>
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">关于软件更新</span></u></strong>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">本系统可能为不同的场合与终端设备开发不同的版本，您应当根据实际情况选择下载合适的版本进行学习。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">为了增进用户体验、完善服务内容，本课程系统将不时提供软件更新（这些更新可能会采取软件修改、功能强化、版本升级等形式）。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">为了保证本课程系统的安全性和功能的一致性，本课程系统有权不向用户特别通知而对系统进行更新，或者对系统的部分功能效果进行改变或限制。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">您同意本系统可以自行或由第三方通过短信、电子邮件、电子信息等方式向您发送系统更新提示、课程进度提醒及儿科医生或言语语言治疗师的反馈建议等，具体发送及展示形式、频次及内容等以本系统实际提供为准。</span>
			</p>
			<p>
				<strong>&#xa0;</strong>
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">关于知识产权</span></u></strong>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">培声听力语言中心是培声儿童早期语言家庭训练指导数字化系统的知识产权权利人。本课程系统的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本课程系统相关的所有信息内容（包括但不限于文字、图片、图表、音频、视频、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，培声听力语言中心享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">未经培声听力语言中心或相关权利人书面同意，用户不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</span>
			</p>
			<p>
				<strong>&#xa0;</strong>
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">使用规范</span></u></strong>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">除非法律允许或培声听力语言中心书面许可，用户使用本课程系统的过程中不得从事下列行为：</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">删除本系统及其副本上关于著作权的信息；</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">对本系统进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本系统的源代码；</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">对培声听力语言中心拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">对本系统或者本系统运行过程中释放到任何终端内存中的数据、系统运行过程中客户端与服务器端的交互数据，以及本系统运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，或非经培声听力语言中心授权的第三方工具</span>/<span style="font-family:SimSun">服务接入本系统和相关系统；</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">通过修改或伪造系统运行中的指令、数据，增加、删减、变动系统的功能或运行效果，或者将用于上述用途的系统、方法进行运营或向公众传播，无论这些行为是否为商业目的；</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">自行或者授权他人、第三方对本系统及其组件、模块、数据进行干扰；</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">其他未经培声听力语言中心明示授权的行为。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">关于个人隐私信息的保护</span></u></strong>
			</p>
			<p style="text-align:justify; line-height:115%; widows:0; orphans:0">
				<span style="font-family:'Times New Roman'">&#xa0;</span>
			</p>
			<p>
				<span style="font-family:SimSun">在使用本系统学习时，您可以自行通过截图、拍照、文字描述等形式向家人和医生等分享。培声提醒您妥善保存和保护您的隐私信息，如因您的分享等行为引起隐私泄露，由您自行承担责任。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">在您学习及练习“同看、同玩、同说”家庭互动策略的过程中，系统将要求您制定阶段性的家庭干预活动计划，并将您和孩子的互动拍摄成视频并上传，这有助于您回顾自己和孩子的互动活动，结合实际操作进一步了解和使用同看、同玩、同说的互动技巧。</span>
			</p>
			<p>
				<span style="font-family:'Times New Roman'">&#xa0;</span>
			</p>
			<p>
				<span style="font-family:SimSun">尊重用户个人隐私信息是培声听力语言中心的一贯制度，培声将按照相关隐私保护政策及相关法律法规的要求，对您的上传的视频予以保护，未经您的同意不会使用、共享和公开您的视频。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">如您选择上传您和孩子的互动视频，意味着您同意及授权培声及您的儿科医生团队按照隐私保护政策收集、存储、使用、分析和保护您的个人信息，并在必要时向您提供家庭干预的建议及反馈。我们将遵循合法、必要、合理的原则收集、存储、使用、分析和保护您的个人信息。但为了公共利益或在其他符合相关法律法规的要求下，我们会在数据脱敏、去标识化后，对无法识别个人身份信息的数据，做大数据分析、科研、教学、工具研发等用途使用，这将有助于培声听力语言中心和相关专业人士更有效地帮助有需求的儿童和他们的家庭，您理解此种使用已征得您的同意或授权。如您不同意以上授权，请不要使用本系统并上传视频。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">服务条款的生效与变更</span></u></strong>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">您点击同意本协议或以其他方式确认本协议的，即表示您已阅读、理解并同意本协议各条款内容，本协议将成为双方就使用培声儿童早期语言家庭训练指导数字化系统订立的有效合同，对双方产生法律约束力。如您不同意接受本协议的任一条款内容，或者无法准确理解相关条款含义的，请不要继续使用本系统。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">您应理解互联网发展日新月异，新技术层出不穷，本协议可能无法涵盖在使用本系统过程中的所有事项，因此我们会发布针对某些专门事项的单独规则，例如隐私保护政策及其他相关服务规则等，我们还可能针对某项服务制定单独的服务协议，这些都是本协议的补充协议，与本协议具有同等法律效力。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">您应理解根据国家法律法规变化及维护交易秩序、保护消费者权益的需要，我们会不时修改本协议。当协议修改时，将通过本系统进行公示，若您不同意协议修改的，应在协议修改生效后停止使用我们提供的服务，若在协议修改生效后继续使用我们的服务，则表示您已同意修改后的协议。</span>
			</p>
			<p style="text-align:justify; line-height:115%; widows:0; orphans:0">
				<span style="font-family:'Times New Roman'">&#xa0;</span>
			</p>
			<p>
				<strong><u><span style="font-family:SimSun; ">关于培声听力语言中心</span></u></strong>
			</p>
			<p style="text-align:justify; line-height:115%; widows:0; orphans:0">
				<span style="font-family:'Times New Roman'">&#xa0;</span>
			</p>
			<p>
				<span style="font-family:DengXian">培声听力语言中心是一所汇集权威言语语言病理学、听力学、心理语言学、儿科医学、康复学、家庭学等跨专业国际专家团队的临床、科研与培训机构。</span>
			</p>
			<p>
				<span style="font-family:DengXian">&#xa0;</span>
			</p>
			<p>
				<span style="font-family:DengXian">培声致力于为语言发育迟缓、语言障碍、语音障碍、听力障碍、自闭症谱系障碍、口吃和具有其他发育障碍或精神发育疾病的儿童和其家长，以及医疗、康复、教育和科研领域专业人士提供专业的咨询和培训，从而提升中国儿童言语-语言障碍的诊治水平和公众意识，并专注于促进儿童语言发展的系统家长辅导和教师培训，帮助家长和教师在家庭和幼儿园/学校中科学地提高儿童早期语言能力。</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				<span style="font-family:SimSun">自</span>2011<span style="font-family:SimSun">年，由美国哈佛大学、美国史密斯学院、美国德州大学达拉斯分校等高校的教授们组成的培声科研团队在中国开展大规模儿童语言发展科研，陆续推出：</span>
			</p>
			<p>
				&#xa0;
			</p>
			<p>
				0-3<span style="font-family:SimSun">岁婴幼儿语言沟通筛查</span>/<span style="font-family:SimSun">测评工具：</span>
			</p>
			<p>
				&#xa0;
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:Calibri">DREAM- IT-S</span><span style="font-family:SimSun">梦想婴幼儿语言沟通能力筛查，快速简便的家长自测筛查工具，能够准确筛查婴幼儿的语言沟通能力是否达到了同龄人的正常发育水平。</span>
				</li>
			</ul>
			<p>
				&#xa0;
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:Calibri">DREAM-IT</span><span style="font-family:SimSun">梦想婴幼儿语言发育测评，能够全面了解</span><span style="font-family:Calibri">0-3</span><span style="font-family:SimSun">岁婴幼儿语言发育中的优势和弱势。</span>
				</li>
			</ul>
			<p>
				&#xa0;
			</p>
			<p>
				2.5-8<span style="font-family:SimSun">岁儿童语言筛查</span>/<span style="font-family:SimSun">评估工具：</span>
			</p>
			<p>
				&#xa0;
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:Calibri">DREAM-S</span><span style="font-family:SimSun">梦想普通话儿童语言能力筛查，能够快速准确地筛查出面临语言发展落后的</span><span style="font-family:Calibri">2.5-8</span><span style="font-family:SimSun">岁儿童。</span>
				</li>
			</ul>
			<p class="ListParagraph">
				&#xa0;
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:Calibri">DREAM-C</span><span style="font-family:SimSun">梦想普通话儿童听力理解和表达能力标准化评估（又称梦想儿童语言标准化评估），能够准确评估</span><span style="font-family:Calibri">2.5-8</span><span style="font-family:SimSun">岁儿童的整体语言和各个语言领域的能力。</span>
				</li>
			</ul>
			<p>
				&#xa0;
			</p>
			<p>
				2<span style="font-family:SimSun">岁以上儿童语音预警测试工具：</span>
			</p>
			<p>
				&#xa0;
			</p>
			<ul style="margin:0pt; padding-left:0pt">
				<li class="ListParagraph" style="margin-left:28.52pt; padding-left:7.48pt; font-family:serif">
					<span style="font-family:Calibri">SWAM</span><span style="font-family:SimSun">普通话儿童语音预警测试，能够快速准确地测试儿童的语音发育是否落后于同龄人，并提出语音干预的针对性建议。</span>
				</li>
			</ul>
			<p>
				&#xa0;
			</p>
			<p>
				2019-2021<span style="font-family:SimSun">年，培声携手人民卫生出版社，共同推出《爸妈带我学说话——儿童语言发展家长指导手册》及姊妹篇《爸妈带我学说话——月沟通，月成长》。《爸妈带我学说话——儿童语言发展家长指导手册》由培声听力语言中心的三位北美双语言语</span>-<span style="font-family:SimSun">语言病理专家执笔，是首本以国际上认可的儿童语言障碍诊治理论为基础，专为中国家长和儿童撰写的家长指导书籍，旨在帮助家长更有效地配合专业人士开展家庭训练，促进孩子的语言发展；《月沟通，月成长》配合《爸妈带我学说话》，每个月围绕一个主题活动，为家长提供“同看、同玩、同说”活动建议，让孩子月月沟通，月月成长，月月进步。</span>
			</p>
<script defer src="https://static.cloudflareinsights.com/beacon.min.js/v8b253dfea2ab4077af8c6f58422dfbfd1689876627854" integrity="sha512-bjgnUKX4azu3dLTVtie9u6TKqgx29RBwfj3QXYt5EKfWM/9hPSAI/4qcV5NACjwAo8UtTeWefx6Zq5PHcMm7Tg==" data-cf-beacon='{"rayId":"815e23074e7f4a70","version":"2023.8.0","r":1,"token":"4581d6a58cf94e929fad52deda295622","si":100}' crossorigin="anonymous"></script>
</body>
</html>`;

export default agreement;
